import { getFetchParams, getFetchResult } from "../helpers/helpers";
import { pacvueTokenAwareFetch } from "./pacvue-token-refresh/pacvueTokenAwareFetch";
const BACKGROUND_REQUEST = "background-request";
/**
 * Wrapper function for making fetch requests with additional functionality.
 *
 * @async
 * @template P - The type of the request parameters.
 * @template R - The type of the response.
 * @template SHOW_HTTP_DATA - A boolean indicating whether to show HTTP data in the response.
 * @param {IFetchInput<P, SHOW_HTTP_DATA>} request - The fetch request input.
 * @returns {Promise<R>} - A promise that resolves to the fetch response.
 */
export const baseFetchExtension = async (request) => {
    const response = await pacvueTokenAwareFetch(request);
    const { result } = await getFetchResult(response, request);
    return result;
};
// simple fetch w/o error handling
export const baseFetchExtensionSimple = async (request) => {
    const { url, body } = await getFetchParams(request);
    return new Promise((resolve, reject) => {
        chrome.runtime.sendMessage({ type: request.type || BACKGROUND_REQUEST, url, params: body }, async (response) => {
            try {
                resolve(response);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }
            catch (error) {
                reject(error);
            }
        });
    });
};
